import { render, staticRenderFns } from "./File.vue?vue&type=template&id=f7e3963c&scoped=true"
import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"
import style0 from "./File.vue?vue&type=style&index=0&id=f7e3963c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e3963c",
  null
  
)

export default component.exports